import { Box } from "@react-three/flex";
import HeadshotBox from "../Boxes/HeadshotBox";
import LinkBox from "../Boxes/LinkBox";
import TitleBox from "../Boxes/TitleBox";
import GeoFlex from "../Flexes/GeoFlex";
import ImgFlex from "../Flexes/ImgFlex";
import TxtFlex from "../Flexes/TxtFlex";


function PageOne({ scale, handleThreshold, viewport }) {

  return (
    <>
      {/* <Box
        dir='column'
        width='100%'
        minHeight='100%'
        height='auto'
        maxHeight='100%'
        margin={scale}
        align='center'
        justify='center' */}
        {/* // marginBottom={12 * scale}
      > */}
        {/* <TitleBox 
          scale={scale}
          onReflow={handleThreshold}
          align='center'
        /> */}
        <HeadshotBox
          scale={scale}
          onReflow={handleThreshold}
          align='center'
          viewport={viewport}
        />
      {/* </Box> */}
    </>
  );
};

export default PageOne;